import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Card } from "@app/@shared/models/card";


@Injectable({
  providedIn: "root",
})
export class CardsService {
  constructor(private httpClient: HttpClient) {}

  getCardByEmail(domain: string, username: string): Promise<Card> {
    return this.httpClient.get<Card>(`/companies/${domain}/cards/${username}`).toPromise();
  }

}
